import ReferralsHero from '@/ui/components/referrals/hero/referrals-hero'
import ReferralPerks from '@/ui/components/referrals/perks/referrals-perk'
import ReferralsTable from '@/ui/components/referrals/table/referrals-table'
import { useEffect, useState } from 'react'
import ReferralsApi from '@/infrastructure/api/referrals'
import { useAppSelector } from '@/redux/hooks'
import { useSendReferral } from '@/application/send-referral'
import { toast } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'
import {
  ReferralsApiGetReferralsByGroupRequest,
  ReferralspbReferral
} from '@itsrever/rever-api'

export default function Referrals() {
  const [referrals, setReferrals] = useState<ReferralspbReferral[]>([])
  const { sendReferral, isLoading, error, success } = useSendReferral()

  const user = useAppSelector((store) => store.userApi.getMe.response.user)

  const { t } = useTranslation()

  const getReferrals = async () => {
    if (!user || !user.group) return

    const args: ReferralsApiGetReferralsByGroupRequest = {
      ecommerceGroup: user.group
    }

    const response = await ReferralsApi.getReferralsByGroup(args)

    if (!response) {
      setReferrals([])
      return
    }
    setReferrals(response)
  }

  useEffect(() => {
    getReferrals()
  }, [])

  useEffect(() => {
    if (success) {
      toast({
        text: t('referrals.toast_messages.success'),
        variant: 'success'
      })

      getReferrals()
    }
  }, [isLoading, success, error])

  return (
    <div className="flex h-full flex-col items-center gap-6 overflow-y-scroll p-8 [&::-webkit-scrollbar]:hidden">
      <div className="w-full max-w-[1400px]">
        <ReferralsHero
          sendReferral={sendReferral}
          isLoading={isLoading}
          success={success}
        />
      </div>
      <div className="w-full max-w-[1400px]">
        <ReferralPerks />
      </div>
      <div className="w-full max-w-[1400px]">
        <ReferralsTable referrals={referrals} />
      </div>
    </div>
  )
}

export interface Referral {
  referral_id: string
  referrer_group: string
  referrer_email: string
  referred_email: string
  referred_phone: string
  referred_brand: string
  website: string
  referred_time: string
  status: string
}
